/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const CALCULATE_SERVICE_CART = 'MFE/CHECKOUT/CALCULATE_SERVICE_CART';
export const CALCULATE_SERVICE_CART_COMPLETED = 'MFE/CHECKOUT/CALCULATE_SERVICE_CART_COMPLETED';
export const CALCULATE_CART = 'MFE/CHECKOUT/CALCULATE_CART';
export const CALCULATE_CART_COMPLETED = 'MFE/CHECKOUT/CALCULATE_CART_COMPLETE';

export const CALCULATE_SHIPPING_PAYMENT_METHOD_CHANGED = 'MFE/CHECKOUT/CALCULATE/SHIPPING/PAYMENT/METHOD/CHANGED';
export const CALCULATE_SHIPPING_PAYMENT_METHOD_CHANGED_COMPLETED = 'MFE/CHECKOUT/CALCULATE/SHIPPING/PAYMENT/METHOD/CHANGED/COMPLETED';

export const RETRY_CALCULATE_SHIPPING_ATTEMPT = 'MFE/CHECKOUT/RETRY_CALCULATE_SHIPPING_ATTEMPT';
export const CLEAR_CALCULATE_SHIPPING_ATTEMPT = 'MFE/CHECKOUT/CLEAR_CALCULATE_SHIPPING_ATTEMPT';
export const UPDATE_CALCULATE_SHIPPING_APPLIED = 'MFE/CHECKOUT/UPDATE_CALCULATE_SHIPPING_APPLIED';
